import { useState } from 'react';
import { Link } from 'react-router';
import { APP_NAME } from '@/lib/constants';

export default function DataDeletionPage() {
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-border">
        <div className="mx-auto max-w-7xl flex items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/" className="text-primary font-bold text-xl">{APP_NAME}</Link>
          <Link to="/" className="text-sm text-text-secondary hover:text-text transition-colors">Back to Home</Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-text">Data Deletion Request</h1>
        <p className="mt-4 text-lg text-text-secondary">
          Request deletion of your personal data and documents from our platform.
        </p>

        {submitted ? (
          <div className="mt-10 bg-success/10 border border-success/20 rounded-xl p-6 text-center">
            <h3 className="font-semibold text-success">Request Submitted</h3>
            <p className="mt-1 text-sm text-text-secondary">
              We have received your data deletion request. We will verify your identity and process your request.
              You may be contacted for additional verification.
            </p>
          </div>
        ) : (
          <form onSubmit={(e) => { e.preventDefault(); setSubmitted(true); }} className="mt-10 space-y-5">
            <div>
              <label htmlFor="applicationNumber" className="block text-sm font-medium mb-1.5">Application Number</label>
              <input id="applicationNumber" type="text" required placeholder="GIC-2026-XXXXXX" className="w-full rounded-lg border border-border px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
            </div>
            <div>
              <label htmlFor="phone" className="block text-sm font-medium mb-1.5">Verified Phone Number</label>
              <input id="phone" type="tel" required className="w-full rounded-lg border border-border px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-1.5">Email (optional)</label>
              <input id="email" type="email" className="w-full rounded-lg border border-border px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
            </div>
            <div>
              <label htmlFor="reason" className="block text-sm font-medium mb-1.5">Reason for deletion (optional)</label>
              <textarea id="reason" rows={3} className="w-full rounded-lg border border-border px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary resize-y" />
            </div>
            <div className="p-4 bg-bg border border-border rounded-lg">
              <p className="text-sm text-text-secondary">
                <strong>Important:</strong> After deletion, your application data and uploaded documents will be permanently removed.
                This action cannot be undone. We may retain anonymised data for analytical purposes.
                We will verify your identity through OTP before processing the deletion.
              </p>
            </div>
            <button type="submit" className="rounded-lg bg-error px-6 py-3 text-sm font-semibold text-white hover:bg-red-700 transition-colors">
              Request Data Deletion
            </button>
          </form>
        )}
      </main>

      <footer className="border-t border-border">
        <div className="mx-auto max-w-3xl px-4 py-6 text-center text-xs text-text-secondary">
          <p>&copy; {new Date().getFullYear()} {APP_NAME}. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
